import type { CSSProperties, ReactNode } from "react";
import { TYPE } from "@chess/shared";
import { useTheme } from "@/theme/ThemeProvider";

interface Props {
  children: ReactNode;
  color?: string;
  style?: CSSProperties;
}

export function BrLabel({ children, color, style = {} }: Props) {
  const p = useTheme();
  return (
    <div
      style={{
        fontSize: 10,
        fontWeight: 700,
        fontFamily: TYPE.mono,
        letterSpacing: 1.5,
        textTransform: "uppercase",
        color: color || p.fgMuted,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
